import { regionsSlice } from "./regionsSlice";
import * as actions from "./regionsActions";
import * as selectors from "./regionsSelectors";

export { actions };
export { selectors };
export default regionsSlice.reducer;
